import gql from "graphql-tag";

export const ME_FOR_MENU = gql`
  query meForMenu {
    me {
      id
      point {
        id
        availableAmount
      }
    }
  }
`;

export const MENU = gql`
  query Menu($name: String) {
    menu (name: $name) {
      id
      jsonContent
    }
  }
`

export const UI_COMPONENT = gql`
  query uiComponent ($name: String!, $desktopSize: String, $mobileSize: String) {
    uicomponent (name: $name) {
      id
      name
      items {
        id
        name
        imageWebUrl(size: $desktopSize)
        imageMobileUrl(size: $mobileSize)
        title
        body
        link
        isActive
      }
    }
  }
`;
